// extracted by mini-css-extract-plugin
export default {"shimmer":"CancelOrder_shimmer__CN4iM","dark_shimmer":"CancelOrder_dark_shimmer__AGpd3","cancel":"CancelOrder_cancel__MoF0S","action":"CancelOrder_action__2AHUT"};